export default __webpack_public_path__ + "static/media/Kunal.2620d217.jpeg";